import { makeStyles } from "@material-ui/core";

export const useAcademicStyles = makeStyles(() => ({
  infoContainer: {
    display: "flex",
    alignItems: "center",
  },
  name: {
    maxWidth: 580,
    fontSize: 16,
    fontWeight: "bold",
    color: " #535358",
    paddingRight: 8,
  },
  subName: {
    fontSize: 14,
    fontWeight: "bold",
    color: " #828190",
    paddingRight: 16,
  },
  programsCount: {
    fontSize: 14,
    color: "#828190",
  },
  accordionDetails: {
    width: "100%",
    "& > div": {
      marginBottom: 8,
    },
  },
  disabled: {
    opacity: 0.6,
    background: "#f8f9fb",
  },
  highlightedSummary: {
    "&&": {
      background: "#ffeab0",
    },
  },
}));
